import useFavoritedContent from './use-favorited-content';

export { useFavoritedContent };

export default useFavoritedContent;
